// Mock data for ARKI - Opere In Pietra

export const siteInfo = {
  name: "ARKI",
  tagline: "Opere In Pietra",
  subtitle: "Maestri della Pietra Naturale: Tradizione e Innovazione.",
  description: "Trasformiamo ogni spazio esterno in un'opera destinata a durare nel tempo.",
  phone: "+393498725035",
  email: "delprete.arki@libero.it",
  whatsapp: "https://wa.me/393498725035",
  instagram: "https://www.instagram.com/arkistonedesign_srls?igsh=MXB3ZmZubjVmdWx4bg%3D%3D&utm_source=qr",
  tiktok: "https://www.tiktok.com/@arkistonedesign?lang=it-IT",
  logo: "https://alessandro081.carrd.co/assets/images/image03.png?v=bed71e8c",
  logoFull: "https://customer-assets.emergentagent.com/job_recipe-pages/artifacts/65dnudco_IMG_0576.png",
  dashboardImage: "https://customer-assets.emergentagent.com/job_recipe-pages/artifacts/i2f4ulvv_17f37a7c-5b1b-4cef-a880-852ffdcd1106.jpeg",
  landingImage: "https://customer-assets.emergentagent.com/job_recipe-pages/artifacts/6e9wnd5d_2EB5D69F-7763-4D4E-84C2-276AEC9C9FCF.jpeg"
};

export const menuItems = [
  { id: "tradizione", label: "TRADIZIONE" },
  { id: "prodotti", label: "PRODOTTI E SERVIZI" },
  { id: "galleria", label: "GALLERIA" },
  { id: "contattaci", label: "CONTATTACI" }
];

export const tradizioneContent = {
  title: "L'arte della pietra, tramandata nel tempo",
  paragraphs: [
    "Ogni nostra pavimentazione nasce da un sapere antico, dove le mani dell'uomo guidano la materia. Ogni cubetto è posato a mano secondo la regola dell'arte. Unendo la maestria della tradizione artigiana all'architettura moderna, costruiamo superfici resistenti e con un'estetica che solo la vera artigianalità può offrire."
  ],
  secondTitle: "Esperienza e futuro",
  secondParagraphs: [
    "La nostra è una storia che parla di famiglia, eredità di valori e di un mestiere che si impara in silenzio, osservando il ritmo del martello e la precisione di uno sguardo esperto.",
    "Ho imparato l'arte della posa da mio padre, da lui ho appreso che un lavoro fatto bene richiede pazienza e dedizione assoluta, lavorare fianco a fianco significa unire la sua esperienza alla mia voglia di guardare al futuro."
  ],
  imageBlackWhite: "https://customer-assets.emergentagent.com/job_recipe-pages/artifacts/gl554wrv_FullSizeRender.jpeg",
  imageColor: "https://customer-assets.emergentagent.com/job_recipe-pages/artifacts/5k1jsezn_IMG_0575.jpeg"
};

export const prodottiContent = {
  title: "I Nostri Servizi",
  services: [
    {
      id: "posa",
      title: "Posa",
      description: "Pavimentazioni in porfido del Trentino, cubetti e lastre posate a regola d'arte",
      fullDescription: "Siamo specializzati nella posa artigianale di Porfido, pietre naturali e pavimentazioni di pregio. La nostra missione è unire la solidità della pietra a un design elegante e curato nei minimi dettagli.",
      features: ["Ogni tipo di posa per cubetti", "Lastre regolari e irregolari", "Binderi e cordoli"],
      showGalleryLink: true
    },
    {
      id: "fornitura",
      title: "Fornitura e Complementi d'Arredo",
      description: "Forniture su misura e oggettistica in pietra lavica artigianale",
      fullDescription: "Offriamo forniture su misura per ogni esigenza progettuale. Dal carattere intramontabile del Porfido, alla resistenza del Granito o per l'eleganza vulcanica della Pietra Lavica. Diverse tipologie di taglio e finiture per adattarci alle specifiche tecniche del tuo cantiere.",
      secondDescription: "Dal cuore del vulcano alla tua casa.\n\nLa nostra oggettistica in pietra lavica è un omaggio alla forza della natura e alla tradizione artigiana. Ogni pezzo è scolpito a mano, trasformando la pietra lavica — eterna, solida e materica — in complementi d'arredo unici. Non sono semplici accessori, ma frammenti di storia vulcanica modellati per dare carattere e prestigio ai tuoi spazi, sia interni che esterni.",
      features: [],
      showGalleryLink: false,
      showInstagramLink: true
    },
    {
      id: "mosaici-decorativi",
      title: "Mosaici Decorativi",
      description: "Disegni e motivi personalizzati per rendere unico ogni progetto",
      fullDescription: "Creiamo mosaici decorativi unici, dalla rosa dei venti ai motivi geometrici più elaborati. Ogni disegno viene realizzato su misura secondo le esigenze del cliente, trasformando semplici pavimentazioni in vere opere d'arte.",
      features: ["Rosa dei venti", "Motivi geometrici", "Stemmi e loghi", "Disegni personalizzati"],
      showGalleryLink: true,
      showInstagramLink: false
    },
    {
      id: "resinatura",
      title: "Resinatura",
      description: "Trattamenti protettivi e resinatura per pavimentazioni in pietra",
      fullDescription: "La resinatura è un trattamento fondamentale per proteggere e valorizzare le pavimentazioni in pietra. Applichiamo resine di alta qualità che penetrano in profondità garantendo massima durabilità.",
      benefitsList: [
        {
          title: "ESTETICA PERSONALIZZATA",
          description: "Grazie a materiali innovativi, le fughe scure creano un contrasto elegante con la pietra, superando la resa estetica del cemento tradizionale."
        },
        {
          title: "INFINITI COLORI",
          description: "Ampia scelta di tonalità e finiture grazie alla varietà del pietrisco utilizzato."
        },
        {
          title: "MASSIMA RESISTENZA",
          description: "Un sistema elastico progettato per carichi pesanti e traffico intenso. Resiste a gelo, acidi e sbalzi termici. È fonoassorbente e disponibile in versione drenante o non drenante."
        },
        {
          title: "VELOCITÀ DI POSA",
          description: "Carrabile in sole 24 ore. La posa è semplice, senza giunti di dilatazione e non produce scarti in cantiere."
        },
        {
          title: "SICUREZZA ED ECOLOGIA",
          description: "Conforme alle normative europee su igiene e sicurezza. È un materiale non infiammabile, facile da smaltire e trasportare."
        }
      ],
      features: [],
      showGalleryLink: false,
      showInstagramLink: true
    }
  ]
};

export const galleriaImages = [
  {
    id: 1,
    src: "https://customer-assets.emergentagent.com/job_recipe-pages/artifacts/r8ylwp3c_1.jpeg",
    alt: "Pavimentazione in porfido - Casa moderna"
  },
  {
    id: 2,
    src: "https://customer-assets.emergentagent.com/job_recipe-pages/artifacts/td5a06it_2.jpeg",
    alt: "Mosaico chiave di violino in porfido"
  },
  {
    id: 3,
    src: "https://customer-assets.emergentagent.com/job_recipe-pages/artifacts/x3l4o8gz_3.jpeg",
    alt: "Vialetto con mosaico decorativo"
  },
  {
    id: 4,
    src: "https://customer-assets.emergentagent.com/job_recipe-pages/artifacts/14ihxxcc_4.jpeg",
    alt: "Mosaico floreale in porfido"
  },
  {
    id: 5,
    src: "https://customer-assets.emergentagent.com/job_recipe-pages/artifacts/px3t4kmz_5.jpeg",
    alt: "Dettaglio resinatura fughe"
  },
  {
    id: 6,
    src: "https://customer-assets.emergentagent.com/job_recipe-pages/artifacts/bq6co0x8_6.jpeg",
    alt: "Piazzale in pietra lavica con vista Etna"
  },
  {
    id: 7,
    src: "https://customer-assets.emergentagent.com/job_recipe-pages/artifacts/hdgk8lgg_07.jpg",
    alt: "Mosaico rosa dei venti con palme"
  },
  {
    id: 8,
    src: "https://customer-assets.emergentagent.com/job_recipe-pages/artifacts/b3f2hsqr_7.jpeg",
    alt: "Mosaico spirale giardino"
  },
  {
    id: 9,
    src: "https://customer-assets.emergentagent.com/job_recipe-pages/artifacts/44h50552_10.jpeg",
    alt: "Pavimentazione lastre casa campagna"
  },
  {
    id: 10,
    src: "https://customer-assets.emergentagent.com/job_recipe-pages/artifacts/yamx1ip3_9.jpeg",
    alt: "Vasi in pietra lavica artigianali"
  },
  {
    id: 11,
    src: "https://customer-assets.emergentagent.com/job_recipe-pages/artifacts/lm6u3g2k_11.jpeg",
    alt: "Fontane e vasi in pietra lavica"
  },
  {
    id: 12,
    src: "https://customer-assets.emergentagent.com/job_recipe-pages/artifacts/c7cos4ul_012.jpg",
    alt: "Piazzetta con mosaici decorativi ondulati"
  },
  {
    id: 13,
    src: "https://customer-assets.emergentagent.com/job_recipe-pages/artifacts/j9xyug6x_12.jpeg",
    alt: "Cortile con posa ad archi e aiuola"
  },
  {
    id: 14,
    src: "https://customer-assets.emergentagent.com/job_recipe-pages/artifacts/6m3hcbha_441E7194-87C1-46F2-B0CB-57949FA64F4E.jpeg",
    alt: "Vialetto villa con mosaico cuore"
  },
  {
    id: 15,
    src: "https://customer-assets.emergentagent.com/job_recipe-pages/artifacts/8bv4ooef_a28b8bbc-9831-4fa6-ac6c-4e90c154ec0a.jpeg",
    alt: "Dettaglio posa cubetti a mano"
  },
  {
    id: 16,
    src: "https://customer-assets.emergentagent.com/job_recipe-pages/artifacts/vfnbilp9_d3ddecd9-2314-40e7-9e0f-b5b4c92e2e84.jpeg",
    alt: "Vialetto in lastre di pietra con giardino"
  },
  {
    id: 17,
    src: "https://customer-assets.emergentagent.com/job_recipe-pages/artifacts/hxbgtybs_FullSizeRender%281%29.jpeg",
    alt: "Viale decorativo con mosaico centrale"
  },
  {
    id: 18,
    src: "https://customer-assets.emergentagent.com/job_recipe-pages/artifacts/rmwtv0hg_foto.jpeg",
    alt: "Piazzale cubetti posa a ventaglio"
  },
  {
    id: 19,
    src: "https://customer-assets.emergentagent.com/job_recipe-pages/artifacts/sgxre9mp_8.jpeg",
    alt: "Pigne decorative in pietra lavica"
  }
];

export const backgroundImage = "https://customer-assets.emergentagent.com/job_recipe-pages/artifacts/tekfsq86_WhatsApp%20Image%202026-02-11%20at%2018.44.18.jpeg";
